<template>
  <div :class="$style.container">
    <div :class="$style.contentSection">
      <div v-if="activeAuditList.length === 0" :class="$style.boxContainer">
        <section class="section">
          <p :class="$style.noDataText">No data collection period found.</p>
          <p>Please accept data collection period invitation to view</p>
        </section>
      </div>
      <p-data-table
        v-if="activeAuditList.length > 0"
        :data="activeAuditList"
        :hoverable="true"
        :noDataText="`No data collection period found.`"
        :class="$style.table"
      >
        <template slot="thead">
          <tr>
            <td :class="[$style.headerText, $style.auditTitleCell]">
              Data Collection Period Title
            </td>
            <td :class="$style.headerText" width="40%">Period</td>
          </tr>
        </template>
        <template slot="tbody" slot-scope="{ data }">
          <tr v-for="item in data" :key="item.id">
            <td
              v-if="new Date(item.startDate) > dateToday"
              class="display-flex"
            >
              <p :class="$style.disableAuditTitle">{{ item.name }}</p>
              <b-tooltip
                label="Records cannot be submitted for upcoming data collection periods."
                type="is-dark"
                position="is-right"
                size="is-small"
                style="cursor: pointer"
              >
                <b-icon
                  :class="$style.infoIcon"
                  icon="information-outline"
                  size="is-small"
                >
                </b-icon>
              </b-tooltip>
            </td>
            <td v-else :class="$style.auditTitleCell">
              <router-link
                :to="`/audits/` + item.id + `/homepage#dataCollectionSheet`"
              >
                {{ item.name }}
              </router-link>
            </td>
            <td>{{ getDurationText(item.startDate, item.endDate) }}</td>
          </tr>
        </template>
      </p-data-table>
    </div>
    <div>
      <button
        v-if="archivedAuditList.length > 0"
        @click="showArchivedList ? hideArchivedAudits() : showArchivedAudits()"
        :class="$style.archivedAuditBtn"
      >
        <span>View Archived Data Collection Period</span>
        <span v-if="showArchivedList" class="icon">
          <i class="fas fa-chevron-up"></i>
        </span>
        <span v-else class="icon">
          <i class="fas fa-chevron-down"></i>
        </span>
      </button>
      <div
        v-if="showArchivedList"
        :class="[$style.contentSection, $style.archivedAuditList]"
      >
        <p-data-table
          :data="archivedAuditList"
          :hoverable="true"
          :noDataText="`No data collection period found.`"
          :class="$style.table"
        >
          <template slot="thead">
            <tr>
              <td :class="$style.auditTitleArchivedCell">Title</td>
              <td width="40%">Duration</td>
              <td width="20%">Date Archived</td>
            </tr>
          </template>
          <template slot="tbody" slot-scope="{ data }">
            <tr v-for="item in data" :key="item.id">
              <td
                v-if="new Date(item.startDate) > dateToday"
                :class="$style.auditTitleArchivedCell"
              >
                {{ item.name }}
              </td>
              <td
                v-else-if="new Date(item.endDate) < dateToday"
                :class="$style.auditTitleArchivedCell"
              >
                {{ item.name }}
              </td>
              <td v-else :class="$style.auditTitleArchivedCell">
                <router-link
                  :to="`/audits/` + item.id + `/homepage#dataCollectionSheet`"
                >
                  {{ item.name }}
                </router-link>
              </td>
              <td>{{ getDurationText(item.startDate, item.endDate) }}</td>
              <td>{{ formatDate(item.updatedAt) }}</td>
            </tr>
          </template>
        </p-data-table>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import dayjs from 'dayjs';
import { DATE_FORMAT, DATE_TIME_FORMAT } from '@/utils/date.util';

@Component({ components: {} })
export default class AuditListDataCollector extends Vue {
  @Prop()
  public activeAuditList!: any[];
  @Prop()
  public archivedAuditList!: any[];

  public showArchivedList: boolean = false;
  public dateToday: Date = new Date();

  public formatDate(s: string) {
    return dayjs(s).format(DATE_FORMAT);
  }

  public getDurationText(startDate: string, endDate: string) {
    if (startDate === null && endDate === null) {
      return 'N/A';
    } else {
      if (endDate !== null) {
        return `${dayjs(startDate).format(DATE_TIME_FORMAT)} - ${dayjs(
          endDate,
        ).format(DATE_TIME_FORMAT)}`;
      } else {
        return `from ${dayjs(startDate).format(DATE_TIME_FORMAT)}`;
      }
    }
  }

  public showArchivedAudits() {
    this.showArchivedList = true;
  }

  public hideArchivedAudits() {
    this.showArchivedList = false;
  }
}
</script>
<style lang="scss" module>
.container {
  margin-bottom: 5rem;
  .contentSection {
    border-radius: 6px;
    .headerText {
      color: #9e9e9e;
      font-size: 14px;
    }
  }
  .archivedAuditBtn {
    background: unset;
    border: unset;
    font-size: 14px;
    span {
      color: #00205b;
    }
  }
  .archivedAuditList {
    margin-top: 16px;
  }
}
.boxContainer {
  flex-grow: 1;
  line-break: auto;
  padding: 10px;
  color: $grey;
  font-size: 12px;
  text-align: center;
  box-shadow: 0 2px 2px #dbdbdb;
  border: 0.5px solid #dbdbdb;
  border-radius: 6px;
  background: #ffffff;
  overflow-x: auto;
  overflow: visible;

  .noDataText {
    font-size: 18px;
    font-weight: bold;
    color: #9f9f9f;
  }
}
.auditTitleCell {
  width: 60%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.auditTitleArchivedCell {
  width: 40%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.disableAuditTitle {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #99a6be;
  font-weight: bold;
  cursor: default;
}
.infoIcon {
  display: block !important;
  padding: 2px 0 0 5px;
}
.table {
  table {
    table-layout: fixed;
  }
}
</style>
